// Roster helpers — deactivated people (Settings → Users → Deactivate) keep their name on the records they
// already own, but leave quick pills and new-assignment pickers.
export const isActivePerson = (p) => p && p.active !== false;

// Pills: active people only.
export const activePeople = (list) => (list || []).filter(isActivePerson);

// Assignment pickers: active people, plus the one already assigned (by name or id) so the saved value still renders.
export const assignablePeople = (list, current, key = "name") =>
  (list || []).filter((p) => isActivePerson(p) || (current && p[key] === current));
